// polyfills
require('core-js/features/array/filter');
require('core-js/features/array/for-each');
require('core-js/features/array/index-of');
require('core-js/features/array/map');
require('core-js/features/array/reduce');
require('core-js/features/array/flat');
require('core-js/features/array/from');
require('core-js/features/object/assign');
require('core-js/features/object/entries');
require('core-js/features/object/keys');
require('core-js/features/object/values');
require('core-js/features/string/trim');
require('core-js/features/promise');
require('core-js/features/math/sign');
require('core-js/features/symbol');

require('lib/bootstrap');
require('lib/wafer');
require('lib/autosize');
require('lib/segmentio/analytics');

require('util/global');
require('util/ui');
require('util/analytics');
require('util/csrf');
require('util/content_type');
require('util/latex');
require('util/autosave');
require('util/sticky');
require('util/flags');
require('util/modal_helpers');
require('util/cookies');
require('util/latex_loader');
require('util/text_formatter');
require('util/app_version');
require('util/urls');
require('util/cursor');
require('util/onload');
